import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IUpdateMeetingCostPayload {
    data: {
        cost: number
    }
    id: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IUpdateMeetingCostState {
    status: string
    data: any
    errors: any
}

const initialState: IUpdateMeetingCostState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const updateMeetingCost = createSlice({
    name: 'meeting/update-meeting-cost',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IUpdateMeetingCostPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const updateMeetingCostActions = updateMeetingCost.actions
export default updateMeetingCost.reducer
